<template>
  <div class="teacher">
    <div class="teacher__name">
      <label for="name">ФИО</label>
      <InputText
        id="name"
        type="text"
        placeholder="Фамилия, имя, отчество"
      />
    </div>
    <div class="teacher__status">
      <label for="status">Должность</label>
      <InputText
        id="status"
        type="text"
        placeholder="Должность"
      />
    </div>
    <div class="teacher__education">
      <label for="education">Образование</label>
      <Textarea
        id="education"
        type="text"
        autoResize rows="10"
        cols="70"
        placeholder="Описание"
      />
    </div>
    <div class="teacher__qualification">
      <label for="qualification">Образование</label>
      <Textarea
        id="qualification"
        type="text"
        autoResize rows="10"
        cols="70"
        placeholder="Описание"
      />
    </div>
    <div class="teacher__course course">
      <h2 class="course__title">Учебные курсы</h2>
      <ckeditor
        :editor="editor"
        :config="editorConfig"
      />
    </div>
    <div class="teacher__contacts">
      <label for="contacts">Контакты</label>
      <InputText
        id="contacts"
        type="text"
        placeholder="Контакты"
      />
    </div>
    <div class="teacher__buttons">
        <BaseBtn blue text="Отменить"/>
        <BaseBtn blue text="Сохранить"/>
      </div>
  </div>
</template>

<script>
import { ref } from 'vue'
import BaseBtn from '@/components/ui/BaseBtn.vue'

import InputText from 'primevue/inputtext'
import Textarea from 'primevue/textarea'

import Editor from 'ckeditor5-custom-build/build/ckeditor'

export default {
  name: 'AddTeacherModal',
  components: {
    BaseBtn,
    InputText,
    Textarea
  },
  props: {
  },
  setup () {
    const editor = ref(Editor)

    const editorConfig = ref({})

    return {
      editor,
      editorConfig
    }
  }
}
</script>

<style lang="scss" scoped>
.teacher {
  display: flex;
  flex-direction: column;
  width: 887px;

  &__name,
  &__status,
  &__education,
  &__qualification,
  &__contacts {
    position: relative;
    display: flex;
    margin-bottom: 16px;
  }

  &__course,
  .course {
    width: 664px;
    margin-bottom: 16px;

    &__title {
      margin-left: 15px;
      font-size: 12px;
      text-align: left;
      color: #1BA6DA;
      background-color: #FFFFFF;
    }
  }

  &__buttons {
    display: flex;
    justify-content: center;
    gap: 36px;
  }

  :deep(.p-inputtext) {
    width: 664px;
    border-radius: 4px;
  }

  :deep(label) {
    position: absolute;
    top: -7px;
    left: 15px;
    z-index: 5;
    font-size: 12px;
    color: #1BA6DA;
    background-color: #FFFFFF;
  }

  :deep(input::placeholder) {
    color: #A8A8A8;
  }
}
</style>
